import {defineStore} from "pinia";
import {computed, ref} from "vue";

export const useLoadingStore = defineStore('loading', () => {
    // 1. state => ref
    // 2. getters => computed
    // 3. actions => function

    const isShow = ref(false);
    const is = computed(() => isShow.value);

    const on = () => {
        isShow.value = true;
    }

    const off = () => {
        isShow.value = false;
    }

    return {is, on, off};
})